export default "skymp5-front/b1b86172cd084fe910f2115b21cb2340.png";